/** @jsx jsx */
import { useStaticQuery, graphql } from "gatsby"
import { useSpring, animated as a } from "react-spring"
import { Text, Flex, Button, Box, jsx } from "theme-ui"
import BlockContent from "@sanity/block-content-to-react"

import { HowItWorks } from "../svg"

function FlavorNotes({ flavors, index, isOpen, setIsOpen }) {
  const spring = useSpring({
    opacity: isOpen ? 1 : 0,
  })

  const styles = {
    container: {
      zIndex: 100,
      position: "relative",
      maxWidth: "600px",
      maxHeight: "315px",
      "@media screen and (max-height: 600px)": {
        maxHeight: "250px",
      },
      "p, button": {
        fontSize: ["18px", null, "16px", "18px"],
      },
      button: {
        padding: "0px",
        background: "transparent",
      },
    },
    header: {
      paddingRight: "50px",
      justifyContent: "space-between",
    },
    button: {
      zIndex: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontSize: "18px",
      padding: "0.25em",
      border: "none",
      background: "transparent",
      height: "38px",
      "span, svg": {
        zIndex: 1,
      },
      span: {
        marginLeft: "1.25em",
        textTransform: "uppercase",
        color: isOpen ? flavors[index].primaryColor : "#FFF",
      },
    },
    pane: {
      transform: "translate(-30px,-60px)",
      pointerEvents: isOpen ? "all" : "none",
      background: "#fff",
      padding: "80px 20px 30px",
      boxShadow: "0 0 10px 0 rgba(0,0,0,0.50)",
      borderRadius: "16px",
      height: "auto",
      overflow: "hidden",
    },
    inner: {
      paddingTop: "0px",
      p: {
        marginTop: "1em",
      },
    },
    details: {
      overflow: "auto",
      "@media screen and (max-height: 700px)": {
        maxHeight: "285px",
      },
      "@media screen and (max-height: 600px)": {
        maxHeight: "200px",
      },
    },
  }

  const data = useStaticQuery(graphql`
    query HowItWorksQuery {
      sanityCaseBuilder(_id: { eq: "caseBuilder" }) {
        howItWorks: _rawHowItWorks
      }
    }
  `)

  const BlockRenderer = props => {
    if (props.node.style === "normal") {
      return (
        <Text as="p" variant="secondary" color="#333">
          {props.children}
        </Text>
      )
    }
    return BlockContent.defaultSerializers.types.block(props)
  }

  const { howItWorks } = data.sanityCaseBuilder

  return (
    <Box sx={styles.container}>
      <Flex sx={styles.header}>
        <Button onClick={() => setIsOpen(!isOpen)} sx={styles.button}>
          <HowItWorks active={isOpen} />
          <Text as="span" variant="secondary">
            {isOpen ? "CLOSE" : "HOW IT WORKS"}
          </Text>
        </Button>
      </Flex>
      <a.div
        style={{
          ...styles.pane,
          ...spring,
        }}
      >
        <Box sx={styles.inner}>
          <Text
            variant="secondary"
            as="p"
            sx={{ color: flavors[index].primaryColor }}
          >
            HOW IT WORKS
          </Text>
          <Box sx={styles.details}>
            <BlockContent
              blocks={howItWorks}
              serializers={{
                types: {
                  block: BlockRenderer,
                },
              }}
            />
          </Box>
        </Box>
      </a.div>
    </Box>
  )
}

export default FlavorNotes
